import classNames from 'classnames';
import { Fragment } from 'react';
import { BaseCard } from '~/components/Card';
import { useChallengeBoostCriteria } from '~/components/Challenge/Boost/ChallengeBoost.hooks';
import { useFriendAbilities } from '~/components/Evolve/Ability/FriendAbility.hooks';
import { T } from '~/components/I18n';
import { Boost2D } from '~/components/Icon';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { Popup, PopupProps } from '~/components/Modal/Popup/Popup';
import { formatBoost } from '~/components/Util/number';
import styles from './FriendAbilitiesPopup.module.scss';

export type FriendAbilitiesPopupProps = {
  className?: string;
} & PopupProps;

export const FriendAbilitiesPopup = ({ className, ...props }: FriendAbilitiesPopupProps) => {
  const {
    data: { totalBoost, boostDetail },
  } = useFriendAbilities();

  const {
    data: { maxPetBoost },
  } = useChallengeBoostCriteria();

  return (
    <Popup
      className={classNames(styles.root, className)}
      title={<T name="citizen_friendsboost_popup_title" />}
      description={
        <T name="citizen_friendsboost_popup_desc1" options={[formatBoost(maxPetBoost)]} />
      }
      {...props}>
      <BaseCard className={styles.body} shadow>
        <DescriptionList
          layout="horizontal"
          className={classNames(styles.descriptionList, styles.receipt)}>
          {boostDetail.map(({ growth, boost, holdingNum }) => (
            <Fragment key={growth}>
              <dt>
                {growth}(x{holdingNum})
              </dt>
              <dd>{formatBoost(boost)}%</dd>
            </Fragment>
          ))}
        </DescriptionList>
        <DescriptionList
          layout="horizontal"
          className={classNames(styles.descriptionList, styles.totalReceipt)}>
          <dd className={classNames('divider', styles.divider)} />
          <dt>
            <T name="citizen_checkin_complete_total" />
          </dt>
          <dd className={styles.total}>
            <Boost2D className={styles.icon} />
            {formatBoost(totalBoost)}%
          </dd>
        </DescriptionList>
      </BaseCard>
    </Popup>
  );
};
